// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles des liens externes de consultation. Livres avec le composant qui les
   utilise : tout ecran qui importe liensConsultation.tsx est coiffe, sans dependre
   de la feuille de style d'une page precise. */

/* Le selecteur est prefixe \`a\` et decline sur :visited et :hover parce que
   index.css:110 pose \`a, a:visited, a:hover { text-decoration: none }\`. Les deux
   pseudo-classes y pesent (0,1,1), contre (0,1,0) pour une classe seule : sans ce
   renfort a (0,2,1), le soulignement saute au survol ET au repos des que le lien a
   ete visite. */
a.lien-externe,
a.lien-externe:visited,
a.lien-externe:hover {
  color: #f97316;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

a.lien-externe:hover {
  color: #ea580c;
}

/* Repli quand l'URL n'est pas renseignee : meme place, mais rien qui ressemble a
   un lien cliquable — le candidat ne doit pas cliquer dans le vide. */
.lien-externe-inactif {
  color: #374151;
}

/* Bloc des quatre liens en tete de la section « Avis de marché ». */
.liens-consultation {
  list-style: none;
  margin: 0 0 1.6rem 0;
  padding: 0 0 1.6rem 0;
  border-bottom: 1px solid #e5e7eb;
}

.liens-consultation__item {
  font-size: 1.3rem;
  color: #374151;
  line-height: 1.6;
  /* Les URL AWS sont longues et sans espace : sans coupure, elles poussent la
     largeur de la modale au lieu de revenir a la ligne. */
  overflow-wrap: anywhere;
  word-break: break-word;
}

.liens-consultation__item + .liens-consultation__item {
  margin-top: 0.6rem;
}

.liens-consultation__libelle {
  font-weight: 600;
  color: #595959;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/liensConsultation.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;;;;gBAIgB;AAChB;;;EAGE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;sEACsE;AACtE;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB;0DACwD;EACxD,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* Styles des liens externes de consultation. Livres avec le composant qui les\n   utilise : tout ecran qui importe liensConsultation.tsx est coiffe, sans dependre\n   de la feuille de style d'une page precise. */\n\n/* Le selecteur est prefixe `a` et decline sur :visited et :hover parce que\n   index.css:110 pose `a, a:visited, a:hover { text-decoration: none }`. Les deux\n   pseudo-classes y pesent (0,1,1), contre (0,1,0) pour une classe seule : sans ce\n   renfort a (0,2,1), le soulignement saute au survol ET au repos des que le lien a\n   ete visite. */\na.lien-externe,\na.lien-externe:visited,\na.lien-externe:hover {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\na.lien-externe:hover {\n  color: #ea580c;\n}\n\n/* Repli quand l'URL n'est pas renseignee : meme place, mais rien qui ressemble a\n   un lien cliquable — le candidat ne doit pas cliquer dans le vide. */\n.lien-externe-inactif {\n  color: #374151;\n}\n\n/* Bloc des quatre liens en tete de la section « Avis de marché ». */\n.liens-consultation {\n  list-style: none;\n  margin: 0 0 1.6rem 0;\n  padding: 0 0 1.6rem 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.liens-consultation__item {\n  font-size: 1.3rem;\n  color: #374151;\n  line-height: 1.6;\n  /* Les URL AWS sont longues et sans espace : sans coupure, elles poussent la\n     largeur de la modale au lieu de revenir a la ligne. */\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.liens-consultation__item + .liens-consultation__item {\n  margin-top: 0.6rem;\n}\n\n.liens-consultation__libelle {\n  font-weight: 600;\n  color: #595959;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
